import React from 'react';
import { Button } from '@doxyme/ui';
import { FormattedMessage } from 'react-intl';
import './TroubleshootingWizardActions.scss';
export const TroubleshootingWizardActions = ({ actions }) => {
    if (!actions)
        return null;
    return <>
    {actions.primary && actions.secondary &&
            <div className='troubleshooting-wizard-actions'>
      <Button className="troubleshooting-wizard-actions__button" size='medium' color="secondary" btnStyle="outline" onClick={actions.secondary.onClick}><FormattedMessage id={actions.secondary.text}/></Button>
      <Button className="troubleshooting-wizard-actions__button" size='medium' color="primary" onClick={actions.primary.onClick}><FormattedMessage id={actions.primary.text}/></Button>
    </div>}
    {actions.primary && !actions.secondary &&
            <div className='troubleshooting-wizard-actions'>
      <Button className="troubleshooting-wizard-actions__button" size='medium' color="primary" onClick={actions.primary.onClick}><FormattedMessage id={actions.primary.text}/></Button>
    </div>}
  </>;
};
